import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.gatewayData ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-gw-mgmt-form', {
    attrs: {
      "editedItem": _vm.gatewayData,
      "accounts": _vm.plainAccounts
    },
    on: {
      "close": function ($event) {
        _vm.formDialog = false;
      },
      "updated": _vm.updateDetails
    }
  }) : _vm._e()], 1), _c(VRow, {
    staticClass: "pb-0 mx-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showMap ? _c('core-dtwin-map-header-map', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "geoCoordinates": _vm.gatewayCoordinates,
      "dtwTitle": _vm.gatewayData.title,
      "dtwData": _vm.gatewayData,
      "mapInteractive": false
    }
  }) : _c(VCol, {
    staticClass: "pa-0"
  }, [_c(VParallax, {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "240",
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-broadcast-tower`)
    }
  }), _vm._v("\n          " + _vm._s(_vm.gatewayData.title) + "\n        ")], 1)])], 1)], 1), _c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [[_c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.editButton'),
      "prepend-icon": _vm.isIotHubManager ? 'fa-edit' : 'fa-eye',
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        _vm.formDialog = true;
      }
    }
  }), _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.cancel'),
      "prepend-icon": "fa-times",
      "color": "danger"
    },
    on: {
      "click": function ($event) {
        return _vm.viewAllDevices();
      }
    }
  })]], 2)]), _c(VRow, {
    staticClass: "n20-mainrow pb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-8"
  }, [_c(VTabs, {
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#details"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-book-open")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.details')))]) : _vm._e()], 1), _c(VTabsItems, {
    staticClass: "mt-4",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "details",
    attrs: {
      "value": "details"
    }
  }, [!_vm.loading ? _c('niota-classic-gw-mgmt-details-form', {
    attrs: {
      "gatewayData": _vm.gatewayData
    }
  }) : _c(VRow, {
    staticClass: "fill-height",
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-subtitle-1 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.loadingGatewayData')) + "\n                ")]), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VProgressLinear, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "rounded": "",
      "height": "6"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };